import axiosInstance from "~/shared/api/axios-instance";

export const deleteFloorPlan = async (params: {
  branchUid: string;
  versionId?: number;
  floorPlanId: number;
}) => {
  const { data } = await axiosInstance.delete(
    `branches/${params.branchUid}/floor-plans/${params.floorPlanId}/`,
    { params: { version: params.versionId } },
  );
  return data;
};
